import React from "react";
import {
    Box,
    Typography,
    Avatar,
    Paper,
    Divider,
    Stack,
    IconButton,
} from "@mui/material";
import AttachmentIcon from "@mui/icons-material/AttachFile";
import DownloadIcon from "@mui/icons-material/Download";
import { useGetActionTrackerCommentsQuery } from "store/slices/apis/actionTrackerSlice";
import moment from "moment";
import CommentAttachments from "./CommentAttachments";

const comments = [
    {
        id: 1,
        user: { name: "Ashok Verma", avatar: "" },
        text: "Initial project files uploaded. Please review.",
        createdAt: "2025-10-31T09:15:00Z",
        attachments: [
            { name: "project_plan.pdf", url: "#" },
            { name: "wireframe.png", url: "#" },
        ],
    },
    {
        id: 2,
        user: { name: "Priya Sharma", avatar: "" },
        text: "Reviewed the files — looks good! Let’s schedule a meeting tomorrow.",
        createdAt: "2025-10-31T11:30:00Z",
        attachments: [],
    },
    {
        id: 3,
        user: { name: "John Doe", avatar: "" },
        text: "Updated the plan document with new budget details.",
        createdAt: "2025-10-31T13:45:00Z",
        attachments: [{ name: "budget_update.xlsx", url: "#" }],
    },
];

function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */

    for (i = 0; i < string?.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

function stringAvatar(name) {
    return {
        sx: {
            bgcolor: stringToColor(name),
        },
        children: `${name?.split(' ')?.[0]?.[0]}`,
    };
}

const ActionTrackerCommentList = (props) => {
    const { data } = props;
    const trackerComments = useGetActionTrackerCommentsQuery({ actionId: data?.projectActionId })

    return (
        <Box
            sx={{

                mx: "auto",
                // mt: 4,
                display: "flex",
                flexDirection: "column",
                gap: 2,
            }}
        >
            {/* <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Comments & Attachments
            </Typography> */}
            {trackerComments?.data?.data?.length > 0 ?
                trackerComments?.data?.data?.map((comment, index) => (
                    <Paper
                        key={comment.id}
                        elevation={0}
                        sx={{
                            p: 2,
                            border: "1px solid #e0e0e0",
                            borderRadius: "3px",
                            backgroundColor: "#fafafa",
                        }}
                    >
                        {/* Header */}
                        <Stack direction="row" spacing={2} alignItems="center">
                            <Avatar {...stringAvatar(comment?.commentBy)} />
                            <Box>
                                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                    {comment?.commentBy}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    {moment(comment?.createdDate)?.format('LLL')}
                                </Typography>
                            </Box>
                        </Stack>
                        <Typography
                            variant="body2"
                            sx={{ mt: 1.5, color: "#333", lineHeight: 1.6, whiteSpace: "pre-line" }}
                        >
                            {comment?.comment}
                        </Typography>
                        <CommentAttachments comment={comment} />
                    </Paper>
                ))
                : <>
                    <Typography
                        variant="body2"
                        sx={{ mt: 1.5, color: "#333", lineHeight: 1.6 }}
                    >
                        Comments not found.
                    </Typography>
                </>

            }
        </Box>
    );
};

export default ActionTrackerCommentList;
